require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es7.symbol.observable.js
// module id = vu/c
// module chunks = 13